import i18next from "i18next";
import * as React from "react";
import { Action, mk_widget, Widget } from "widgets-for-react";
import { AppState } from "../../cms/state/types.gen";
import { PublicSiteState } from "../../public_site.main.mod";
import { PublicSiteCustomRoutes } from "../custom_pages/types.mod";
import NavItems from "./nav_items";

export const footer: (
  s: AppState<PublicSiteState, PublicSiteCustomRoutes>
) => Widget<
  Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
> = props =>
    mk_widget({
      run: o => {
        return (<footer id="a11y-footer" className="footer">
          <div className="footer__disclaimer disclaimer container gutter--m">
            <div className="disclaimer__text container gutter--m typo--ml ff--primary border-radius--s">
              {i18next.t('general.disclaimer')}
            </div>
            <div className="disclaimer__banner"></div>
          </div>
          <div className="footer__inner container container--m gutter--m">
            <nav className="footer__nav nav nav--footer">
              <div className="nav__inner">
                <NavItems location='footer' cssClass={'bottom'} hasActiveState={false} />
                <div className="footer__socials">
                  <SocialBar {...props} />
                </div>
                <div className="footer__bottom">
                  <NavItems location='copyright' cssClass={'copyright'} hasActiveState={false}
                  after={
                    <li className="nav__item nav__item--copyright">
                      <a className="optanon-toggle-display nav__link nav__link--copyright">{i18next.t('cookiebar.settings')}</a>
                    </li>
                  }
                  />
                  <div className="footer__logo">
                    <svg  width="200px" height="107px" aria-hidden="true">
                      <use xlinkHref="#logo" />
                    </svg>
                  </div>
                </div>
              </div>
            </nav>
          </div>
        </footer>
        )
      }
    });

const SocialBar = (props: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
  if (props.state.options.kind != 'loaded') return null
  const isInternational = window.wp.language !== 'nl'
  const facebook_url = props.state.options.value.acf?.facebook_url
  const twitter_url = props.state.options.value.acf?.twitter_url
  const instagram_url = props.state.options.value.acf?.instagram_url
  const linkedin_url = props.state.options.value.acf?.linkedin_url
  const youtube_url = props.state.options.value.acf?.youtube_url
  const wechat_url = props.state.options.value.acf?.wechat_url
  
  return (
    <div className="socials">
      <h3 className="socials__title typo--ml">{ isInternational? 'Follow us' : 'Volg ons' }</h3>
      <ul className="socials__list">
        { facebook_url && <SocialItem mediaName="Facebook" url={facebook_url} width={20} height={20} /> }
        { instagram_url && <SocialItem mediaName="Instagram" url={instagram_url} width={20} height={20} /> }
        { linkedin_url && <SocialItem mediaName="LinkedIn" icon="icon--linkedin" url={linkedin_url} width={22} height={22} /> }
        { (isInternational && wechat_url) && <SocialItem mediaName="WeChat" icon="icon--wechat" url={wechat_url} width={24} height={24} /> }
        { twitter_url && <SocialItem mediaName="X (Twitter)" icon="icon--x" url={twitter_url} width={20} height={20} /> }
        { youtube_url && <SocialItem mediaName="YouTube" icon="icon--youtube" url={youtube_url} width={20} height={20} /> }
      </ul>
    </div>
  )
}

const SocialItem = (props: { 
  mediaName: string, 
  icon?: string,
  url: string, 
  width: number, 
  height: number,
}) => {
  const {
    mediaName,
    icon,
    url,
    width,
    height,
  } = props
  return (
    <li className="socials__item">
      <a className={`socials__link socials__link--${mediaName}`} href={url} target="_blank" rel="noopeneer noreferrer" title={mediaName}>
        <svg className="socials__icon" width={width} height={height} aria-hidden="true"><use xlinkHref={`#${icon ? icon : `social--${mediaName}` }`} /></svg>
        <span className="socials__label sr-text">{`${mediaName}`}</span>
     </a>
    </li>
  )
}
